<div class="fixed-section">
    <section class="titleBarBg ">
        <div class="container-fluid">
            <div class="row mar-7px">
                <div class="w-3">
                    <img src="./assets/images/newproject.svg" class="pageIcon" alt="">
                </div>
                <div class="w-97">
                    <div class="pageHeadingBar">
                        <div class="row">
                            <div class="col-md-6 align-self-center">
                                <h6 class="pageHeadingText mb-0 text-uppercase">ADHOC QUESTIONS</h6>
                            </div>

                            <div class="col-md-3 align-self-center">
                                <div class="d-flex">
                                    <div class="nav-item dropdown">
                                        <div class="me-1 position-relative  actionButton align-self-center dropdown-toggle"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src="./assets/images/save_icon.svg" class="saveImg me-2" alt=""
                                                title="Save">
                                            <span class="statusValue pe-2">SAVE</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 align-self-center">

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="mt-131  fixedHeaderBg">
        <div class="container-fluid px-2">
            <div class="row">
                <div class="col-md-12 mt-2">
                    <div class="card border-0 stepsBars">
                        <div class="card-body pb-1">
                            <div class="main mx-2 pb-1 ms-0">
                                <!-- <div class="progressbar ml-34">
                                    <ul>
                                        <li>
                                            <p class="label">INITIATED</p>
                                        </li>
                                        <li>
                                            <p class="label">APPROVED</p>
                                        </li>
                                        <li>
                                            <p class="label">PWR LINKED</p>
                                        </li>

                                        <li>
                                            <p class="label">COMPLETED</p>
                                        </li>

                                    </ul>
                                </div> 

                                <div class="progressbar mb-2 ml-34">
                                    <ul>
                                        <li>
                                            <div class="border-div">
                                                <div class="step first">
                                                    <img src="images/initiated_icon.svg" alt="">
                                                </div>
                                            </div>

                                        </li>
                                        <li>
                                            <div class="border-div">
                                                <div class="step second">
                                                    <img src="images/approve_icon.svg" alt="">
                                                    
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="border-div">
                                                <div class="step third">
                                                    <img src="images/link_icon.svg" alt="">
                                                   
                                                </div>
                                            </div>

                                        </li>

                                        <li>
                                            <div class="border-div">
                                                <div class="step seventh">
                                                    <img src="images/completed_icon.svg" alt="">
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div> -->

                                <div class="d-flex w-100 mt-3 ">
                                    <div class="col-md-2">
                                        <div class="row">
                                            <div class="col-md-3 pe-0 align-self-center">
                                                <label>TITLE</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input type="text" placeholder="title here.." class="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-2">
                                        <div class="row">
                                            <div class="col-md-3 pe-0 align-self-center">
                                                <label>CATEGORY</label>
                                            </div>
                                            <div class="col-md-8">
                                                <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories"
                                                    name="category" [showHeader]="true" [filter]="true"
                                                    placeholder="Select Category"
                                                    (ngModelChange)="onSelectedCategory($event)">
                                                    <ng-template pTemplate="header">
                                                        <div class="custom-multiselect-header">
                                                            <span style="padding-right: 5px;">SELECT ALL</span>
                                                        </div>
                                                    </ng-template>
                                                </p-multiSelect>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-2">
                                        <div class="row">
                                            <div class="col-md-3 pe-0 align-self-center">
                                                <label>DATES</label>
                                            </div>
                                            <div class="col-md-8">
                                                <input type="date" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <form [formGroup]="form">
                                <div class="table-responsive mt-2">
                                    <table class="table border-x-0 mb-4 table-bordered table-striped">
                                        <thead>
                                            <tr class="subheaderrr">
                                                <th></th>
                                                <th>Type</th>
                                                <th>TYPE OF REQUEST</th>
                                                <th>DESCRIPTION</th>
                                                <th>RESPONSE OPTIONS</th>
                                                <th>STORE NUMBERS</th>
                                                <th>IMAGE</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="rows">
                                            <tr *ngFor="let row of rows.controls; let i = index" [formGroupName]="i">
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <img src="./assets/images/plus_icon.svg" alt="add"
                                                        style="cursor:pointer;" (click)="duplicateRow(i)">
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <strong>P&G Others</strong>
                                                </td>
                                                <td class="tdHeaderBg">
                                                    <select class="form-select" aria-label="Default select example"
                                                        formControlName="typeOfRequest">
                                                        <option value="">Select Request Type</option>
                                                        <option *ngFor="let tr of typeOfRequests" [value]="tr.id">{{
                                                            tr.name }}</option>
                                                    </select>
                                                </td>
                                                <td class="tdHeaderBg">
                                                    <textarea class="form-control"
                                                        formControlName="description"></textarea>
                                                </td>
                                                <td class="tdHeaderBg">
                                                    <select class="form-select" formControlName="responseOption">
                                                        <option value="">Select Description</option>
                                                        <option value="1">Option 1</option>
                                                        <option value="2">Option 2</option>
                                                    </select>
                                                </td>
                                                <td class="tdHeaderBg">
                                                    <textarea class="form-control" formControlName="storeNumbers"
                                                        placeholder="Copy the store numbers here"></textarea>
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <label for="image-{{i}}" style="cursor:pointer">
                                                        <input type="file" id="image-{{i}}" style="display:none;" />
                                                        <img src="./assets/images/photo.png" />
                                                    </label>
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <img src="./assets/images/close_mark.svg" alt=""
                                                        (click)="deleteRow(i)">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                            <form [formGroup]="stockingPriorityForm">
                                <div class="table-responsive mt-2">
                                    <table class="table datatable border-x-0 mb-4">
                                        <thead>
                                            <tr class="subheaderrr">
                                                <th width="15%">STOCKING PRIORITY </th>
                                                <th width="15%">ITEM NUMBER</th>
                                                <th width="25%" class="text-start">UPC</th>
                                                <th width="15%" class="text-start"> DESCRIPTION</th>
                                                <th width="15%" class="border-end-0">IMAGE</th>
                                                <th width="15%" class="border-end-0">NOTE</th>
                                                <th width="15%" class="text-start">
                                                    <a (click)="exportToExcel()"><img
                                                            src="../../../../assets/images/export.png" height="25"
                                                            width="25" alt=""></a>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody formArrayName="stockingPriorityRows">
                                            <tr *ngFor="let row of stockingPriorityRows.controls ; let index = index"
                                                [formGroupName]="index">

                                                <td class="text-center align-middle tdHeaderBg">
                                                    <img src="./assets/images/plus_icon.svg" alt=""
                                                        (click)="duplicatestockingPriorityRow(index)">
                                                </td>
                                                <td class="tdHeaderBg">
                                                    <div class="position-relative">
                                                        <input type="text" class="form-control w-100"
                                                            formControlName="itemNumber" />
                                                        <img src="./assets/images/magnifying-glass.png" alt=""
                                                            class="glassIcon">
                                                    </div>
                                                </td>
                                                <td class="text-start align-middle tdHeaderBg">
                                                    <label>auto generated number</label>
                                                </td>
                                                <td class="text-start align-middle tdHeaderBg">
                                                    <label>auto generated number</label>
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <img src="./assets/images/photo.png" />
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <textarea class="form-control"
                                                        placeholder="Copy the store numbers here"
                                                        formControlName="priorityNotes"></textarea>
                                                </td>
                                                <td class="text-center align-middle tdHeaderBg">
                                                    <img src="./assets/images/close_mark.svg" alt=""
                                                        (click)="deletestockingPriorityRow(index)">
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>